<template>
  <div v-if="counterStyle === 1" class="row">
    <div
      :class="`${column}`"
      v-for="(counter, index) in counterData"
      :key="index"
    >
      <div :class="`count-box counter-style-1 ${checkTextAlign}`">
        <VisibilitySensor @change="onChange">
          <div class="count-number">
            <countTo
              :endVal="status ? counter.number : 0"
              :autoplay="countUp"
              :duration="3000"
            />
          </div>
        </VisibilitySensor>
        <h5 class="title">{{ counter.title }}</h5>
      </div>
    </div>
  </div>

  <div v-else-if="counterStyle === 2" class="row">
    <div
      :class="`${column}`"
      v-for="(counter, index) in counterData"
      :key="index"
    >
      <div :class="`count-box counter-style-2 ${checkTextAlign}`">
        <VisibilitySensor @change="onChange">
          <div class="count-number">
            <countTo
              :endVal="status ? counter.number : 0"
              :autoplay="countUp"
              :duration="3000"
            />
          </div>
        </VisibilitySensor>
        <h5 class="title">{{ counter.title }}</h5>
        <p class="description">{{ counter.description }}</p>
      </div>
    </div>
  </div>

  <div v-else-if="counterStyle === 3" class="row">
    <div
      :class="`${column}`"
      v-for="(counter, index) in counterData"
      :key="index"
    >
      <div
        :class="`count-box counter-style-2 color-variation ${checkTextAlign}`"
      >
        <VisibilitySensor @change="onChange">
          <div class="count-number">
            <countTo
              :endVal="status ? counter.number : 0"
              :autoplay="countUp"
              :duration="3000"
            />
          </div>
        </VisibilitySensor>
        <h5 class="title">{{ counter.title }}</h5>
        <p class="description">{{ counter.description }}</p>
      </div>
    </div>
  </div>

  <div v-else-if="counterStyle === 4" class="row">
    <div
      :class="`${column}`"
      v-for="(counter, index) in counterData"
      :key="index"
    >
      <div :class="`count-box counter-style-2 border-style ${checkTextAlign}`">
        <VisibilitySensor @change="onChange">
          <div class="count-number">
            <countTo
              :endVal="status ? counter.number : 0"
              :autoplay="countUp"
              :duration="3000"
            />
          </div>
        </VisibilitySensor>
        <h5 class="title">{{ counter.title }}</h5>
        <p class="description">{{ counter.description }}</p>
      </div>
    </div>
  </div>

  <div v-else-if="counterStyle === 5" class="row">
    <div
      :class="`${column}`"
      class="mt-3"
      v-for="(counter, index) in counterData"
      :key="index"
    >
      <div
        :class="`count-box counter-style-4 `"
        :style="{
          'background-image': `url(${require(`@/assets/images/${counter.src}`)})`,
        }"
      >
        <VisibilitySensor @change="onChange">
          <div class="count-number">
            <countTo
              :endVal="status ? counter.number : 0"
              :autoplay="countUp"
              :duration="3000"
            />
            <span class="tag">{{ counter.tag }}</span>
          </div>
        </VisibilitySensor>
        <h5 class="counter-title">{{ counter.title }}</h5>
        <p class="counter-desc">{{ counter.description }}</p>
        <!-- <div class="counter-bg" :style="{backgroundImage:url(counter.src)}"></div> -->
      </div>
    </div>
  </div>
</template>

<script>
import VisibilitySensor from "vue-visibility-sensor";
import countTo from "vue-count-to";

export default {
  name: "Counter",
  components: { VisibilitySensor, countTo },
  props: {
    column: {},
    counterStyle: {
      type: Number,
      default: 1,
    },
    textAlign: {
      type: String,
      default: "left",
    },
  },

  data() {
    return {
      countUp: true,
      status: false,
    };
  },
  computed: {
    checkTextAlign() {
      if (this.textAlign === "left") return "text-start";
      else if (this.textAlign === "center") return "text-center";
      else if (this.textAlign === "end") return "text-end";
      else return "";
    },
    counterData() {
      return [
        {
          number: 10,
          tag: this.$t("home.tab.unit"),
          title: this.$t("home.tab.tab01.title"),
          description: this.$t("home.tab.tab01.description"),
          src: "home/count-01.png",
        },
        {
          number: 200,
          tag: "+",
          title: this.$t("home.tab.tab02.title"),
          description: this.$t("home.tab.tab02.description"),
          src: "home/count-02.png",
        },
        {
          number: 140,
          tag: "+",
          title: this.$t("home.tab.tab03.title"),
          description: this.$t("home.tab.tab03.description"),
          src: "home/count-03.png",
        },
        {
          number: 400,
          tag: "+",
          title: this.$t("home.tab.tab04.title"),
          description: this.$t("home.tab.tab04.description"),
          src: "home/count-04.png",
        },
      ];
    },
  },
  methods: {
    onChange(isVisible) {
      if (isVisible) {
        this.status = true;
      }
    },
  },
};
</script>